<form *ngIf="entityForm" [formGroup]="entityForm" mat-dialog-content class="content">
    <div class="steps" [ngClass]="this.formState ? this.formState.steps[this.formState.currentStep] : ''">
        <section id="sire">
            <h1 class="section__title">{{ "posts.actions.create.sections.horse_id" | translate }}</h1>
            <div class="sire__buttons-wrapper">
                <mat-form-field cdkFocusInitial>
                    <mat-label>
                        {{ "posts.actions.create.fields.sire" | translate }}
                    </mat-label>
                    <input matInput formControlName="sire" />
                </mat-form-field>
                <button mat-flat-button color="primary" (click)="hasNoSire()">
                    {{ "posts.actions.create.fields.no_sire" | translate }}
                </button>
            </div>
        </section>
        <section id="horse_informations" formGroupName="horse_informations">
            <h1 class="section__title">{{ "posts.actions.create.sections.horse_informations" | translate }}</h1>
            <mat-form-field>
                <mat-label>{{ "posts.actions.create.fields.horse_name" | translate }}</mat-label>
                <input matInput formControlName="horse_name" />
            </mat-form-field>
            <div class="form-field__wrapper">
                <mat-form-field>
                    <mat-label>
                        {{ "posts.actions.create.fields.horse_year" | translate }}
                    </mat-label>
                    <input matInput type="number" formControlName="horse_year" />
                </mat-form-field>
                <mat-form-field>
                    <mat-label>
                        {{ "posts.actions.create.fields.horse_sex.label" | translate }}
                    </mat-label>
                    <mat-select formControlName="horse_sex">
                        <mat-option value="male">
                            {{
                            "posts.actions.create.fields.horse_sex.options.male" | translate
                            }}
                        </mat-option>
                        <mat-option value="female">
                            {{
                            "posts.actions.create.fields.horse_sex.options.female" | translate
                            }}
                        </mat-option>
                        <mat-option value="hongre">
                            {{
                            "posts.actions.create.fields.horse_sex.options.hongre" | translate
                            }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field>
                    <mat-label>
                        {{ "posts.actions.create.fields.horse_total_earn" | translate }}
                    </mat-label>
                    <input matInput type="number" formControlName="horse_total_earn" />
                </mat-form-field>
            </div>
            <mat-form-field>
                <mat-label>
                    {{ "posts.actions.create.fields.horse_record.label" | translate }}
                </mat-label>
                <input matInput formControlName="horse_record"
                    [placeholder]="'posts.actions.create.fields.horse_record.placeholder' | translate" />
            </mat-form-field>
            <div class="form-field__wrapper">
                <mat-form-field>
                    <mat-label>
                        {{ "posts.actions.create.fields.horse_father" | translate }}
                    </mat-label>
                    <input matInput formControlName="horse_father" />
                </mat-form-field>
                <mat-form-field>
                    <mat-label>
                        {{ "posts.actions.create.fields.horse_mother" | translate }}
                    </mat-label>
                    <input type="text" matInput formControlName="horse_mother" />
                </mat-form-field>
            </div>
            <mat-form-field>
                <mat-label>
                    {{ "posts.actions.create.fields.category.label" | translate }}
                </mat-label>
                <mat-select formControlName="category">
                    <mat-option value="yearling">
                        {{"posts.actions.create.fields.category.options.yearling" | translate }}
                    </mat-option>
                    <mat-option value="training">
                        {{"posts.actions.create.fields.category.options.training" | translate }}
                    </mat-option>
                    <mat-option value="two_years">
                        {{"posts.actions.create.fields.category.options.two_years" | translate }}
                    </mat-option>
                    <mat-option value="out_training">
                        {{"posts.actions.create.fields.category.options.out_training" | translate }}
                    </mat-option>
                    <mat-option value="broodmare">
                        {{"posts.actions.create.fields.category.options.broodmare" | translate }}
                    </mat-option>
                    <mat-option value="stallion">
                        {{"posts.actions.create.fields.category.options.stallion" | translate }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field>
                <mat-label>
                    {{ "posts.actions.create.fields.horse_location" | translate }}
                </mat-label>
                <input matInput formControlName="horse_location" />
            </mat-form-field>
            <div class="image-wrapper">
                <mat-form-field style="width: 100%;">
                    <ngx-mat-file-input formControlName="horse_photos" accept=".jpeg,.jpg" [required]="false"
                        [valuePlaceholder]="'posts.actions.create.fields.horse_photos' | translate" [multiple]="true">
                    </ngx-mat-file-input>
                    <mat-icon matSuffix svgIcon="file-import"></mat-icon>
                </mat-form-field>
                <div *ngIf="havePhotoSetted()" class="photos-previewer">
                    <img *ngFor="let imagePreview of imagesPreview" class="preview" [src]="imagePreview"
                        alt="photo du cheval">
                </div>
              <small>  Type: JPEG, Taille: 5mo par image.</small>
            </div>
            <div>
                <span *ngIf="getHorsePhotosErrors()" style="color: red">
                    {{
                    getUploadErrors(getHorsePhotosErrors())["maxSize"] &&
                    ("errors.upload_limit" | translate) + " 500 ko"
                    }}
                </span>
            </div>
            <mat-form-field style="min-height: 160px;">
                <mat-label>{{"posts.actions.create.fields.comments_fr" | translate }}</mat-label>
                <textarea matInput formControlName="comments_fr" style="min-height: 160px;"></textarea>
            </mat-form-field>
            <mat-form-field style="min-height: 160px;">
                <mat-label>{{ "posts.actions.create.fields.comments_en" | translate }}</mat-label>
                <textarea matInput formControlName="comments_en" style="min-height: 160px;"></textarea>
            </mat-form-field>
            <mat-form-field>
                <mat-label>
                    {{ "posts.actions.create.fields.sell_price" | translate }}
                </mat-label>
                <input matInput type="number" formControlName="sell_price" />
            </mat-form-field>
            <div class="simple-row">
                <div>
                    <p>
                        {{ "posts.actions.create.fields.to_negociate.label" | translate }}
                    </p>
                    <mat-slide-toggle matInput formControlName="to_negociate">
                        {{
                        (isNegociating()
                        ? "posts.actions.create.fields.to_negociate.options.yes"
                        : "posts.actions.create.fields.to_negociate.options.no"
                        ) | translate
                        }}
                    </mat-slide-toggle>
                </div>
                <div>
                    <p>
                        {{ "posts.actions.create.fields.taxable_vat.label" | translate }}
                    </p>
                    <mat-slide-toggle matInput formControlName="taxable_vat">
                        {{
                        (isTaxableVat()
                        ? "posts.actions.create.fields.taxable_vat.options.yes"
                        : "posts.actions.create.fields.taxable_vat.options.no"
                        ) | translate
                        }}
                    </mat-slide-toggle>
                </div>
            </div>
        </section>
        <section id="contact_informations" formGroupName="contact_informations">
            <h1 class="section__title">
                {{ "posts.actions.create.sections.contact_informations" | translate }}
            </h1>
            <div class="row">
                <mat-form-field>
                    <mat-label>
                        {{ "posts.actions.create.fields.last_name" | translate }}
                    </mat-label>
                    <input matInput formControlName="last_name" />
                </mat-form-field>
                <mat-form-field>
                    <mat-label>
                        {{ "posts.actions.create.fields.first_name" | translate }}
                    </mat-label>
                    <input matInput formControlName="first_name" />
                </mat-form-field>
            </div>
            <mat-form-field>
                <mat-label>
                    {{ "posts.actions.create.fields.email" | translate }}
                </mat-label>
                <input matInput type="email" formControlName="email" />
            </mat-form-field>
            <mat-form-field>
                <mat-label>
                    {{ "posts.actions.create.fields.mobile_phone_number" | translate }}
                </mat-label>
                <input matInput formControlName="mobile_phone_number" type="tel" />
            </mat-form-field>
            <mat-form-field>
                <mat-label>
                    {{ "posts.actions.create.fields.landline_phone_number" | translate }}
                </mat-label>
                <input matInput formControlName="landline_phone_number" type="tel" />
            </mat-form-field>
            <p>
                {{ "posts.actions.create.fields.contact_is_english.label" | translate }}
            </p>
            <mat-slide-toggle matInput formControlName="is_english">
                {{
                (isEnglish()
                ? "posts.actions.create.fields.contact_is_english.options.yes"
                : "posts.actions.create.fields.contact_is_english.options.no"
                ) | translate
                }}
            </mat-slide-toggle>
            <p>
                {{ "posts.actions.create.fields.mail_confirmation.label" | translate }}
            </p>
            <mat-slide-toggle matInput formControlName="mail_confirmation">
                {{
                (isMailConfirmated()
                ? "posts.actions.create.fields.mail_confirmation.options.yes"
                : "posts.actions.create.fields.mail_confirmation.options.no"
                ) | translate
                }}
            </mat-slide-toggle>
        </section>
        <section id="documents" formGroupName="documents">
            <h1 class="section__title">
                {{ "posts.actions.create.fields.documents.label" | translate }}
            </h1>
            <mat-form-field>
                <mat-label>
                    {{ "posts.actions.create.fields.role.label" | translate }}
                </mat-label>
                <mat-select formControlName="role">
                    <mat-option value="unique_owner">
                        {{"posts.actions.create.fields.role.options.unique_owner" | translate }}
                    </mat-option>
                    <mat-option value="stable_manager">
                        {{"posts.actions.create.fields.role.options.stable_manager" | translate }}
                    </mat-option>
                    <mat-option value="coowner">
                        {{ "posts.actions.create.fields.role.options.coowner" | translate }}
                    </mat-option>
                    <mat-option value="agent">
                        {{ "posts.actions.create.fields.role.options.agent" | translate }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <div class="image-wrapper">
                <mat-form-field style="width: 100%;">
                    <ngx-mat-file-input formControlName="horse_registration" [required]="true"
                        [valuePlaceholder]="'posts.actions.create.fields.documents.options.horse_registration' | translate"
                        [multiple]="false" accept=".png,.jpeg,.jpg,.webp,.pdf"></ngx-mat-file-input>
                    <mat-icon matSuffix svgIcon="file-import"></mat-icon>
                </mat-form-field>
                <div>
                    <span *ngIf="getDocumentError('documents_horse_registration')" style="color: red">
                        {{
                        getUploadErrors(getDocumentError('documents_horse_registration'))["maxSize"] &&
                        ("errors.upload_limit" | translate) + " 500 ko"
                        }}
                    </span>
                </div>
                <img class="preview" [src]="horseRegistrationPreview" *ngIf="haveDocumentSetted('horse_registration')"
                    alt="Carte d'immatriculation du cheval">
            </div>
            <div class="image-wrapper">
                <mat-form-field style="width: 100%;">
                    <ngx-mat-file-input formControlName="certificate_of_sale" [required]="isCoowner()"
                        [valuePlaceholder]="'posts.actions.create.fields.documents.options.certificate_of_sale' | translate"
                        [multiple]="false" accept=".png,.jpeg,.jpg,.webp,.pdf"></ngx-mat-file-input>
                    <mat-icon matSuffix svgIcon="file-import"></mat-icon>
                </mat-form-field>
                <div>
                    <span *ngIf="getDocumentError('documents_certificate_of_sale')" style="color: red">
                        {{
                        getUploadErrors(getDocumentError('documents_certificate_of_sale'))["maxSize"] &&
                        ("errors.upload_limit" | translate) + " 500 ko"
                        }}
                    </span>
                </div>
                <img class="preview" [src]="certificateOfSalePreview" *ngIf="haveDocumentSetted('certificate_of_sale')"
                    alt="Attestation de vente">
            </div>
            <div class="image-wrapper">
                <mat-form-field style="width: 100%;">
                    <ngx-mat-file-input formControlName="certification_of_the_person" [required]="isAgent()"
                        [valuePlaceholder]="'posts.actions.create.fields.documents.options.certification_of_the_person' | translate"
                        [multiple]="false" accept=".png,.jpeg,.jpg,.webp,.pdf"></ngx-mat-file-input>
                    <mat-icon matSuffix svgIcon="file-import"></mat-icon>
                </mat-form-field>
                <div>
                    <span *ngIf="getDocumentError('documents_certification_of_the_person')" style="color: red">
                        {{
                        getUploadErrors(getDocumentError('documents_certification_of_the_person'))[
                        "maxSize"
                        ] && ("errors.upload_limit" | translate) + " 500 ko"
                        }}
                    </span>
                </div>
                <img class="preview" [src]="certificationOfThePersonPreview"
                    *ngIf="haveDocumentSetted('certification_of_the_person')" alt="Attestation de la personne">
            </div>
            <div class="image-wrapper">
                <mat-form-field style="width: 100%;">
                    <ngx-mat-file-input formControlName="extract_kbis" [required]="false"
                        [valuePlaceholder]="'posts.actions.create.fields.documents.options.extract_kbis' | translate"
                        [multiple]="false" accept=".png,.jpeg,.jpg,.webp,.pdf"></ngx-mat-file-input>
                    <mat-icon matSuffix svgIcon="file-import"></mat-icon>
                </mat-form-field>
                <div>
                    <span *ngIf="getDocumentError('documents_extract_kbis')" style="color: red">
                        {{ getUploadErrors(getDocumentError('documents_extract_kbis'))["maxSize"] &&
                        ("errors.upload_limit"
                        | translate)
                        + " 500 ko" }}
                    </span>
                </div>
                <img class="preview" [src]="extractKbisPreview" *ngIf="haveDocumentSetted('extract_kbis')"
                    alt="Extrait Kabis C">
            </div>
        </section>
        <section id="done">
            <mat-icon class="done__check" matSuffix svgIcon="check"></mat-icon>
            <p class="done__text">Formulaire complété, vous pouvez enregistrer le brouillon ou bien déposer l'annonce.
            </p>
        </section>
    </div>
</form>
